import nested from './nested'

const regex = /<(.*?)>/g

const templateString = (template, object) =>
  String(template).replace(regex, (group, path) => nested(object, path))

export default templateString
